
export enum winPanelAssetConfig {
    multi_num_export = "assets/font/multi_num-export.xml",
    multi_value_num_export = "assets/font/multi_value_num-export.xml",
    iconWP_0 = "assets/symbol/static/lv_1.png",
    iconWP_1 = "assets/symbol/static/lv_2.png",
    iconWP_2 = "assets/symbol/static/lv_3.png",
    iconWP_3 = "assets/symbol/static/lv_4.png",
    iconWP_4 = "assets/symbol/static/lv_5.png",
    iconWP_5 = "assets/symbol/static/hv_1.png",
    iconWP_6 = "assets/symbol/static/hv_2.png",
    iconWP_7 = "assets/symbol/static/hv_3.png",
    iconWP_8 = "assets/symbol/static/hv_4.png",
    iconWP_9 = "assets/symbol/static/hv_5.png",
    iconWP_10 = "assets/symbol/static/wild_1x1.png",
    iconWP_11 = "assets/symbol/static/bonus.png",

}